import { useSelector } from 'react-redux'

import { selectEmail, selectUserScid, selectUserFirstName, selectUserLastName, hasPermission } from '.'
import { useAppSelector } from 'store'

export const useCanTestApp = () => useAppSelector((state) => hasPermission(state, 'TEST_COLLEGE_APPLICATION'))
export const useCanManageRoundsAndRequirements = () =>
  useAppSelector((state) => hasPermission(state, 'MANAGE_COLLEGE_APPLICATION_ROUNDS'))
export const useScid = () => useSelector(selectUserScid)
export const useFirstName = () => useSelector(selectUserFirstName)
export const useLastName = () => useSelector(selectUserLastName)
export const useEmail = () => useSelector(selectEmail)
